var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "section",
          { staticClass: "has-text-centered" },
          [_c("loading-spin")],
          1
        )
      : _c(
          "section",
          [
            !_vm.response.ok
              ? _c("div", { staticClass: "section is-mono" }, [_vm._m(1)])
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("admin-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.administracion,
                    settings: _vm.config.administracion,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "administracion", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "administracion", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("repositorio-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.repositorios,
                    settings: _vm.config.repositorios,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "repositorios", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "repositorios", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("recibo-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.recibos,
                    settings: _vm.config.recibos,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "recibos", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "recibos", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("otros-documentos-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.otrosDocumentos,
                    settings: _vm.config.otrosDocumentos,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "otrosDocumentos", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "otrosDocumentos", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("aspectos-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.aspectos,
                    settings: _vm.config.aspectos,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "aspectos", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "aspectos", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("series-documentales-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.seriesDocumentales,
                    settings: _vm.config.seriesDocumentales,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "seriesDocumentales", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "seriesDocumentales", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("autoridad-registro-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.autoridadRegistro,
                    settings: _vm.config.autoridadRegistro,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "autoridadRegistro", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "autoridadRegistro", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.ok
              ? _c("auditorias-brief", {
                  attrs: {
                    idOrganization: _vm.idOrganization,
                    about: _vm.modulos.auditorias,
                    settings: _vm.config.auditorias,
                  },
                  on: {
                    "update:about": function ($event) {
                      return _vm.$set(_vm.modulos, "auditorias", $event)
                    },
                    "update:settings": function ($event) {
                      return _vm.$set(_vm.config, "auditorias", $event)
                    },
                    update: _vm.getData,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrar organización"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Módulos instalados")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tag is-rounded is-medium is-danger" }, [
      _c("i", { staticClass: "fas fa-times fa-fw" }),
      _vm._v(" Sin áreas para mostrar"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }